import React from 'react';
import './UnderConstruction.scss';
import FeatherIcon from 'feather-icons-react';

const UnderConstruction = () => {
  return (
    <div className="under-construction-container">
      <div className="background-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      <div className="glass-card">
        <div className="icon-wrapper">
          <FeatherIcon icon="tool" size="64" className="spinning-icon" />
        </div>
        <h1 className="title">Website Sedang Dalam Pembangunan</h1>
        <p className="description">
          Mohon maaf, saat ini website atau data untuk domain ini belum tersedia atau sedang dalam proses pembaruan.
          Silakan kembali beberapa saat lagi.
        </p>

        <div className="action-buttons">
          <button className="btn" onClick={() => window.location.reload()}>
            <FeatherIcon icon="refresh-cw" size="18" className="btn-icon" />
            Refresh Halaman
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnderConstruction;
